import { Injectable, Optional } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, CanLoad, Route, Router, RouterStateSnapshot, UrlSegment, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services';
import { ACCOUNT_STATUS } from '../models/user';
@Injectable({
  providedIn: 'root'
})
export class BusinessAccountGuard implements CanActivate, CanLoad, CanActivateChild {
  constructor(private router: Router, @Optional() private auth: AuthService) { }

  async canActivateChild(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
    const user = await this.auth.authenticated();
    if (user.business && (user.business.id || user.business._id) && (user.business.role === 'admin') && user.account_status === ACCOUNT_STATUS.APPROVED) {
      return true;
    }
    this.router.navigate([`/`])
    return false
  }

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Promise<boolean> {
    const user = await this.auth.authenticated();
    if (user.business && (user.business.id || user.business._id) && (user.business.role === 'admin') && user.account_status === ACCOUNT_STATUS.APPROVED) {
      return true;
    }
    this.router.navigate([`/`])
    return false
  }
  async canLoad(
    route: Route,
    segments: UrlSegment[]): Promise<boolean> {
    const user = await this.auth.authenticated();
    if (user.business && (user.business.id || user.business._id) && (user.business.role === 'admin') && user.account_status === ACCOUNT_STATUS.APPROVED) {
      return true;
    }
    this.router.navigate([`/`])
    return false
  }
}
